package com.trevorwiebe.timesheet.mileage.domain

data class UsState(
    val name: String,
    val code: String,
    val common: Boolean
)

val US_STATES: List<UsState> = listOf(
    UsState("Alabama", "AL", false),
    UsState("Alaska", "AK", false),
    UsState("Arizona", "AZ", false),
    UsState("Arkansas", "AR", false),
    UsState("California", "CA", false),
    UsState("Colorado", "CO", true),
    UsState("Connecticut", "CT", false),
    UsState("Delaware", "DE", false),
    UsState("Florida", "FL", false),
    UsState("Georgia", "GA", false),
    UsState("Hawaii", "HI", false),
    UsState("Idaho", "ID", false),
    UsState("Illinois", "IL", false),
    UsState("Indiana", "IN", false),
    UsState("Iowa", "IA", true),
    UsState("Kansas", "KS", true),
    UsState("Kentucky", "KY", false),
    UsState("Louisiana", "LA", false),
    UsState("Maine", "ME", false),
    UsState("Maryland", "MD", false),
    UsState("Massachusetts", "MA", false),
    UsState("Michigan", "MI", false),
    UsState("Minnesota", "MN", false),
    UsState("Mississippi", "MS", false),
    UsState("Missouri", "MO", true),
    UsState("Montana", "MT", false),
    UsState("Nebraska", "NE", true),
    UsState("Nevada", "NV", false),
    UsState("New Hampshire", "NH", false),
    UsState("New Jersey", "NJ", false),
    UsState("New Mexico", "NM", false),
    UsState("New York", "NY", false),
    UsState("North Carolina", "NC", false),
    UsState("North Dakota", "ND", true),
    UsState("Ohio", "OH", false),
    UsState("Oklahoma", "OK", true),
    UsState("Oregon", "OR", false),
    UsState("Pennsylvania", "PA", false),
    UsState("Rhode Island", "RI", false),
    UsState("South Carolina", "SC", false),
    UsState("South Dakota", "SD", true),
    UsState("Tennessee", "TN", false),
    UsState("Texas", "TX", true),
    UsState("Utah", "UT", false),
    UsState("Vermont", "VT", false),
    UsState("Virginia", "VA", false),
    UsState("Washington", "WA", false),
    UsState("West Virginia", "WV", false),
    UsState("Wisconsin", "WI", false),
    UsState("Wyoming", "WY", false)
)
